import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import App from "./App";
import "./index.css";
import ScrollToTop from "./components/ScrollToTop";
import RouteTitle from "./components/RouteTitle";

const Services = lazy(() => import("./components/Services"));
const ContactUs = lazy(() => import("./components/ContactUs"));
const AboutUs = lazy(() => import("./components/AboutUs"));
const Policies = lazy(() => import("./components/Policies"));
const WebDevelopment = lazy(() => import("./components/WebDevelopment"));
const UIUXDesign = lazy(() => import("./components/UIUXDesign"));
const SEO = lazy(() => import("./components/SEO"));
const Hosting = lazy(() => import("./components/Hosting"));
const Sitemap = lazy(() => import("./components/Sitemap"));
const WebsiteDesign = lazy(() => import("./components/WebsiteDesign"));
const WebsiteMaintenance = lazy(() => import("./components/WebsiteMaintenance"));
const DeployGuide = lazy(() => import("./components/DeployGuide"));
const Projects = lazy(() => import("./components/Project"));
const InteractiveTesseract = lazy(() => import("./components/InteractiveTesseract"));
const SolarSystem = lazy(() => import("./components/SolarSystem"));
const Location = lazy(() => import("./components/Location"));
const OurClients = lazy(() => import("./components/OurClients"));


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Router>
    <ScrollToTop />
    <RouteTitle />
    <Suspense fallback={null}>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/policies" element={<Policies />} />
        <Route path="/website-development" element={<WebDevelopment />} />
        <Route path="/ui-ux-design" element={<UIUXDesign />} />
        <Route path="/seo" element={<SEO />} />
        <Route path="/hosting" element={<Hosting />} />
        <Route path="/sitemap" element={<Sitemap />} />
        <Route path="/website-design" element={<WebsiteDesign />} />
        <Route path="/website-maintenance" element={<WebsiteMaintenance />} />
        <Route path="/deploy-guide" element={<DeployGuide />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/projects/react.js/interactive-tesseract" element={<InteractiveTesseract />} />
        <Route path="/projects/react.js/solar-system" element={<SolarSystem />} />
        <Route path="/location" element={<Location />} />
        <Route path="/our-clients" element={<OurClients />} />
      </Routes>
    </Suspense>
  </Router>
);